<template>
    <div class="max-w-7xl py-6">
        <h1 class="font-semibold text-xl text-gray-800 leading-tight">
            {{ title }}
        </h1>
    </div>
</template>

<script>
export default {
    name: "PageTitle",
    props: ['title']
}
</script>

<style scoped>

</style>
